import * as React from 'react';
import { IEpiProps } from '../../state-helpers/epi-props';

export interface IEmptyResultsProps {
    epiProps: IEpiProps;
}

export class EmptyResults extends React.Component<IEmptyResultsProps, any> {

    render() {

        return (
            <div className="empty-results-wrapper">
                <div className="empty-results" dangerouslySetInnerHTML={{ __html: this.props.epiProps.emptyResultsText}} />
            </div>
        );
    }
}